import { ContractsService } from '@appStore/contracts/services/contracts.service';
import { BudgetsService } from '@appStore/contracts/services/budgets.service';
import { AgreementsService } from '@appStore/contracts/services/agreements.service';
import { ServiceAgreementService } from '@appStore/contracts/services/service-agreements.service';

export const services: any[] = [
  ContractsService,
  BudgetsService,
  AgreementsService,
  ServiceAgreementService];

export * from '@appStore/contracts/services/contracts.service';
export * from '@appStore/contracts/services/budgets.service';
export * from '@appStore/contracts/services/agreements.service';
export * from '@appStore/contracts/services/service-agreements.service';
